<cerrix-loader
    [cerrixTab]="cerrixTab"
    [attr.data-uiid]="module + '-workspace-loader'"
></cerrix-loader>

<div
    class="workspace"
    [attr.data-uiid]="module + '-workspace'"
    [class.menu-indent]="
        cerrixTab.menu && cerrixTab.menu.menuItems.length > 0 && !tabService.sideMenuTucked
    "
>
    <div class="top-bar">
        <div class="search-area">
            @if (permissions.canAdd) {
                <button
                    data-uiid="button-addnew"
                    class="btn btn-cerrix me-2"
                    (click)="onAddClick.emit()"
                >
                    <i class="fas fa-plus-circle"></i>
                    <span class="d-none d-lg-inline">{{
                        "addNew" | t: { module: moduleLabel || module }
                    }}</span>
                </button>
            }
            <input
                data-uiid="input-searchfilter"
                type="text"
                class="form-control quick-search me-2"
                [placeholder]="'searchPlaceholder' | t: { module: moduleLabel || module }"
                (debounce-input-event)="setActiveData()"
                [(ngModel)]="quickFilter"
                inputTooltip
            />
            @if (!useLightWorkspace) {
                <button
                    data-uiid="button-advanced-configuration"
                    class="btn btn-outline-secondary me-2"
                    (click)="advancedConfigComponent.showConfig()"
                >
                    <i class="fas fa-filter" aria-hidden="true"></i>
                    <span class="d-none d-lg-inline">{{
                        "advancedConfiguration" | t
                    }}</span>
                </button>
            }
            @if (
                activePresetConfig &&
                (activePresetConfig.isOwner ||
                    (permissions.isModuleAdmin && activePresetConfig.isPublic))
            ) {
                <button
                    data-uiid="button-update-preset"
                    class="btn btn-outline-secondary"
                    (click)="workspacePresetManagement.updatePreset()"
                >
                    <i class="fas fa-save" aria-hidden="true"></i>
                    <span class="d-none d-lg-inline">{{
                        "updatePreset" | t
                    }}</span>
                </button>
            }
        </div>
        @if (!useLightWorkspace) {
            <div class="button-area">
                <div class="btn-group" role="group">
                    <button
                        data-uiid="button-workspace-tools"
                        id="workspace-tools"
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i class="fa fa-cog"></i>
                        <span class="d-none d-xl-inline">{{
                            "workspaceTools" | t
                        }}</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="workspace-tools">
                        <!-- Custom buttons -->
                        @for (btnConfig of buttonConfig; track btnConfig) {
                            <div
                                class="dropdown-item d-flex align-items-center"
                                [attr.data-uiid]="'button-workspace-tools-' + btnConfig.text"
                                (click)="processBtnConfigClick(btnConfig)"
                                [hidden]="btnConfig.isDisabled"
                                [disabled]="
                                    (btnConfig.getVisibleRange &&
                                        (!allActiveData || allActiveData.length == 0)) ||
                                    (btnConfig.rowRequired && !highlightedRowID)
                                "
                                [title]="
                                    btnConfig.getVisibleRange &&
                                    (!allActiveData || allActiveData.length == 0)
                                        ? ('dataRequiredAction' | t)
                                        : btnConfig.rowRequired && !highlightedRowID
                                          ? ('activeRowRequiredAction' | t)
                                          : btnConfig.text
                                "
                            >
                                <mat-icon [svgIcon]="btnConfig.icon"></mat-icon>
                                <span class="d-none d-xl-inline ms-2">{{ btnConfig.text }}</span>
                            </div>
                        }
                        @if (buttonConfig && buttonConfig.length > 0) {
                            <div
                                data-uiid="divider-workspace-tools"
                                class="dropdown-divider m-0"
                            ></div>
                        }
                        <!-- Default buttons that are always available -->
                        <div
                            data-uiid="button-workspace-tools-export"
                            class="dropdown-item"
                            (click)="exportData()"
                            [disabled]="
                                isGeneratingExport || !allActiveData || allActiveData.length == 0
                            "
                            [title]="'export' | t"
                        >
                            @if (isGeneratingExport) {
                                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
                            } @else {
                                <i class="fas fa-file-excel fa-fw" aria-hidden="true"></i>
                            }

                            <span class="d-none d-xl-inline ms-2">{{
                                (isGeneratingExport ? "exporting" : "export")
                                    | t
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    @if (presetAccessDenied) {
        <div class="no-data-container" data-uiid="container-preset-access-denied">
            <span class="no-data-text">
                {{ "presetAccessDenied" | t }}
            </span>
        </div>
    } @else if (!allActiveData || allActiveData.length === 0) {
        <div class="no-data-container" data-uiid="container-no-data">
            <span class="no-data-text">{{ "noData" | t }}</span>
        </div>
    }

    <div
        class="table-body"
        [ngClass]="{ 'no-overflow': stretchedHeaders }"
        [hidden]="presetAccessDenied || !allActiveData || allActiveData.length == 0"
    >
        <table data-uiid="table-workspace" class="table table-hover table-sm workspace-table">
            <thead data-uiid="table-workspace-headers">
                <tr>
                    @for (header of activeHeaders; track header) {
                        <th
                            [attr.data-uiid]="'tableheader-workspace-' + header"
                            class="sticky"
                            [class.header-with-icon]="header == sortCol"
                            [title]="headerLookup[header]"
                            (click)="updateSorting(header)"
                            [ngStyle]="{ width: headerWidths[header] + 'px' }"
                        >
                            <span>{{ headerLookup[header] }}</span>
                            @if (header === sortCol) {
                                @if (isSorting) {
                                    <i
                                        [attr.data-uiid]="'icon-workspace-' + header + '-sorting'"
                                        class="fas fa-circle-notch fa-spin"
                                    ></i>
                                } @else {
                                    <i
                                        [attr.data-uiid]="'icon-workspace-' + header + '-sort'"
                                        class="fas fa-sort-amount-{{ sortAsc ? 'up' : 'down' }}"
                                    ></i>
                                }
                            }
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (row of activeData; track row) {
                    <tr
                        [attr.data-uiid]="'tablerow-workspace-row-' + row[idProp]"
                        [ngClass]="{ highlighted: highlightedRowID == row[idProp] }"
                        (click)="rowClicked(row)"
                        (dblclick)="rowDblClicked(row)"
                        (contextmenu)="rowClicked(row)"
                    >
                        @for (header of activeHeaders; track header) {
                            <td
                                [attr.data-uiid]="
                                    'tabledata-workspace-column-' + header + '-row-' + row[idProp]
                                "
                            >
                                @if (row[header]) {
                                    <workspace-cell
                                        [attr.data-uiid]="
                                            'workspacecell-workspace-column-' +
                                            header +
                                            '-row-' +
                                            row[idProp]
                                        "
                                        [configs]="rendererConfig"
                                        [row]="row"
                                        [header]="header"
                                        [width]="headerWidths[header]"
                                        [stretched]="stretchedHeaders"
                                    ></workspace-cell>
                                }
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>

    @if (allActiveData) {
        <div data-uiid="div-bottom-bar" class="bottom-bar disable-selection">
            <div class="btn-group dropup workspace-options">
                <button
                    data-uiid="button-bottom-bar-reload"
                    class="btn btn-outline-secondary"
                    [title]="'reloadTitle' | t"
                    (click)="reloadData()"
                >
                    <i class="fas fa-sync" aria-hidden="true"></i>
                    <span class="d-none d-xl-inline ms-1">{{ "reload" | t }}</span>
                </button>
                <button
                    data-uiid="button-bottom-bar-reset"
                    class="btn btn-outline-secondary"
                    [title]="'resetTitle' | t"
                    (click)="resetWorkspace()"
                >
                    <i class="fas fa-undo" aria-hidden="true"></i>
                    <span class="d-none d-xl-inline ms-1">{{ "reset" | t }}</span>
                </button>
                @if (allActiveData.length > 0) {
                    <button
                        type="button"
                        data-uiid="button-bottom-bar-pagination-amount"
                        class="btn btn-outline-secondary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {{ paginationAmount }} <span class="d-none d-lg-inline">{{
                            moduleLabelPlural || ("modulePlural" | t: { module })
                        }}</span>
                    </button>
                }
                <div class="dropdown-menu">
                    @for (option of paginationAmountOptions; track option) {
                        <a
                            class="dropdown-item"
                            [attr.data-uiid]="'button-bottom-bar-pagination-option-' + option"
                            (click)="setPaginationAmount(option)"
                        >
                            {{
                                "showAmount"
                                    | t
                                        : {
                                              option,
                                              modules: moduleLabelPlural || ("modulePlural" | t: { module })
                                          }
                            }}
                        </a>
                    }
                </div>
            </div>
            @if (allActiveData.length > 0) {
                <div class="btn-group pagination" role="group" aria-label="Basic example">
                    <button
                        type="button"
                        data-uiid="button-bottom-bar-pagination-first"
                        class="btn btn-outline-secondary d-none d-md-inline"
                        [disabled]="paginationIndex <= 0"
                        (click)="setPagination(0)"
                    >
                        {{ "first" | t }}
                    </button>
                    <button
                        type="button"
                        data-uiid="button-bottom-bar-pagination-previous"
                        class="btn btn-outline-secondary pagination-action-prev"
                        [disabled]="paginationIndex <= 0"
                        (click)="setPagination(paginationIndex - 1)"
                    >
                        {{ "previous" | t }}
                    </button>
                    <div class="btn-group dropup" role="group">
                        <button
                            id="allPageNumbers"
                            data-uiid="button-bottom-bar-pagination-page-selection"
                            type="button"
                            class="btn btn-outline-secondary dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span class="d-xl-none">{{ paginationIndex + 1 }}</span>
                            <span class="d-none d-xl-inline">{{
                                "pageOfTotal"
                                    | t: { current: paginationIndex + 1, total: totalPages }
                            }}</span>
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-end all-pages"
                            aria-labelledby="allPageNumbers"
                        >
                            @for (page of allPageNumbers; track page) {
                                <div
                                    class="dropdown-item"
                                    [ngClass]="{ active: paginationIndex == page }"
                                    [attr.data-uiid]="
                                        'button-bottom-bar-pagination-select-page-' + page
                                    "
                                    (click)="setPagination(page)"
                                >
                                    <span class="d-none d-xl-inline">{{
                                        "page" | t
                                    }}</span> {{ page + 1 }}
                                </div>
                            }
                        </div>
                    </div>
                    <button
                        data-uiid="button-bottom-bar-pagination-next"
                        type="button"
                        class="btn btn-outline-secondary pagination-action-next"
                        [disabled]="paginationIndex + 1 >= totalPages"
                        (click)="setPagination(paginationIndex + 1)"
                    >
                        {{ "next" | t }}
                    </button>
                    <button
                        data-uiid="button-bottom-bar-pagination-last"
                        type="button"
                        class="btn btn-outline-secondary d-none d-md-inline"
                        [disabled]="paginationIndex + 1 >= totalPages"
                        (click)="setPagination(totalPages - 1)"
                    >
                        {{ "last" | t }}
                    </button>
                </div>
                <div data-uiid="div-bottom-bar-item-counter" class="data-info d-none d-xl-block">
                    {{
                        "showingRange"
                            | t
                                : {
                                      module: moduleLabel || module,
                                      modules: moduleLabelPlural || ("modulePlural" | t: { module }),
                                      from: paginationIndex * paginationAmount + 1,
                                      to:
                                          paginationIndex + 1 >= totalPages
                                              ? allActiveData.length
                                              : paginationIndex * paginationAmount +
                                                paginationAmount,
                                      total: allActiveData.length
                                  }
                    }}
                </div>
            }
        </div>
    }

    @if (availableHeaders) {
        <workspace-advanced-workspace-config
            [tabID]="tabID"
            [moduleType]="moduleType"
            [moduleSubType]="moduleSubType"
            [filterConfig]="filterConfig"
            [activeFilters]="activeFilters"
            [NumberProperties]="NumberProperties"
            [DateProperties]="DateProperties"
            [allHeaders]="availableHeaders"
            [headerLookup]="headerLookup"
            [activeHeaders]="activeHeaders"
            (ApplyClick)="applyPreset($event)"
            #advancedConfigComponent
        >
        </workspace-advanced-workspace-config>

        <workspace-preset-management
            #workspacePresetManagement
            [cerrixTab]="cerrixTab"
            [moduleType]="moduleType"
            [appendToModuleType]="appendToModuleType"
            (selectedPreset)="applyPresetConfig($event)"
            [allHeaders]="availableHeaders"
            [activeColumns]="activeHeaders"
            [activeSearchKeywords]="activeFilters"
            [activePaginationAmount]="paginationAmount"
            [activeSortCol]="sortCol"
            [sortAsc]="sortAsc"
            [permissions]="permissions"
            [usePresetHyperlink]="usePresetHyperlink"
            [dataUiid]="'workspace-preset-management-' + moduleType + '-' + moduleSubType"
            (presetsReady)="presetRequestChange($event)"
            (presetAccessDenied)="onPresetAccessDenied($event)"
        >
        </workspace-preset-management>
    }
</div>
